import React from 'react';
import { Text, View } from 'react-native';
import { BaseEquipment } from 'fitbeat.models';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
import BulletPointText from '../../ui/components/BulletPointText';

export const WhatYouNeedForWokoutText = ({
  t,
  equipment, // Equipment[]
}) => {
  return (
    <View>
      <Text style={[Theme.textStyle.heading2, {marginBottom: defaultScale(18)}]}>{t('whatYouNeed')}</Text>

      <BulletPointText
        style={Theme.textStyle.bodyCopyReg}
        text={t('whatYouNeedFloor')}
      />

      <BulletPointText
        style={Theme.textStyle.bodyCopyReg}
        text={t('whatYouNeedMat')}
      />

      {BaseEquipment.containsHomeDumbbells(equipment) && (
      <BulletPointText
        style={Theme.textStyle.bodyCopyReg}
        text={t('whatYouNeedDumbbells')}
      />
      )}

      {BaseEquipment.containsBench(equipment) && (
      <BulletPointText
        style={Theme.textStyle.bodyCopyReg}
        text={t('whatYouNeedBench')}
      />
      )}

      {BaseEquipment.containsHomeBench(equipment) && (
        <BulletPointText
          style={Theme.textStyle.bodyCopyReg}
          text={t('whatYouNeedElite')}
        />
      )}

      <Text style={[Theme.textStyle.bodyCopyReg, {marginTop: defaultScale(18)}]}>
        {t('whatYouNeedRecommended')}
      </Text>
    </View>
  );
};
